import { useRef, useState } from "react";
import "./CategoryForm.css";

export default function CategoryForm({ setCategories, token }) {

    const [isExpanded, setIsExpanded] = useState(false);
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [deleted, setDeleted] = useState(false);
    const [color, setColor] = useState("#409eff");
    const [errors, setErrors] = useState({});
    const formRef = useRef(null);
    const baseUrl = process.env.REACT_APP_API_URL;

    // バリデーションチェック
    const validate = () => {
        const newErrors = {};

        if (!name.trim()) {
            newErrors.name = "カテゴリー名は必須です";
        }

        if (name.length > 50) {
            newErrors.name = "50文字以内で入力してください";
        }

        if (description.length > 200) {
            newErrors.description = "200文字以内で入力してください";
        }

        setErrors(newErrors);

        const isValid = Object.keys(newErrors).length === 0;

        // エラーがあればフォームの一番上にスクロール
        if (!isValid) {
            formRef.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }

        return isValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // 入力エラー
        if (!validate()) return;

        const newCategory = {
            name,
            description,
            deleted,
            color,
        };

        const token = localStorage.getItem("token");

        try {
            const res = await fetch(`${baseUrl}/api/categories/add`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
                body: JSON.stringify(newCategory)
            });

            if (!res.ok) {
                throw new Error("登録失敗")
            }

            const savedCategory = await res.json();
            setCategories((prev) => [...prev, savedCategory]);

            setName("");
            setDescription("");
            setDeleted(false);
            setColor("#409eff");

            setIsExpanded(false);

        } catch (err) {
            console.error(err);
            console.error("エラーの詳細:", err);
            alert("エラー発生");
        }
    };

    const handleCancel = () => {

        // リセット
        setName("");
        setDescription("");
        setDeleted(false);
        setColor("#409eff");

        setErrors({});
        setIsExpanded(false);

        // キャンセル時に画面がフォームの最下部にスクロールされる
        setTimeout(() => {
            formRef.current?.scrollIntoView({
                behavior: "smooth",
                block: "end",
            });
        }, 100);

    };

    return (
        <div className="category-form-container">
            <div className="category-form-header">
                <h2>カテゴリー登録</h2>
                <button
                    type="button"
                    className={`toggle-btn ${isExpanded ? "is-active" : ""}`}
                    onClick={() => setIsExpanded(!isExpanded)}
                >
                    {isExpanded ? "−" : "＋"}
                </button>
            </div>

            <div
                ref={formRef}
                className={`form-expandable ${isExpanded ? "is-open" : ""}`}
            >
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>カテゴリー名</label>
                        <input
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                        {errors.name && <p className="error">{errors.name}</p>}
                    </div>

                    <div className="form-group">
                        <label>概要</label>
                        <input
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                        {errors.description && <p className="error">{errors.description}</p>}
                    </div>

                    <div className="form-group">
                        <label>カテゴリーカラー</label>
                        <div className="color-selection-area">
                            <div className="preset-colors">
                                {["#004c9d", "#409eff", "#b7ecff",
                                    "#00b049", "#67c23a", "#93fbc2",
                                    "#b96f00", "#e6a23c", "#eeba8d",
                                    "#d61500", "#ff5d4b", "#fda0c5",
                                    "#9d0ed5", "#909399", "#111111"].map((preset) => (
                                        <div
                                            key={preset}
                                            className={`color-chip ${color === preset ? "is-active" : ""}`}
                                            style={{ backgroundColor: preset }}
                                            onClick={() => setColor(preset)}
                                        />
                                    ))}
                            </div>
                            <div className="selected-color-text">選択中: <strong>{color.toUpperCase()}</strong></div>
                        </div>
                    </div>

                    <button type="button" className="cancel-button" onClick={handleCancel}>
                        キャンセル
                    </button>

                    <button type="submit" className="submit-button">登録</button>
                </form>
            </div>
        </div>
    );
}